// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tip_box":"tip_box-1ZRklzkd","tip":"tip-3KGCclSt"};